
import { DayView } from "./DayView";
import { MonthView } from "./MonthView";
import { WeekTimeGrid } from "./WeekTimeGrid";
import { CalendarViewMode, EventObject } from "./types";

interface CalendarViewProps {
	events: EventObject[];
	viewMode: CalendarViewMode;
	selectedDate: Date;
	onEventClick: (event: EventObject) => void;
	onDateClick: (date: Date) => void;
	onEventDrop: (eventId: string, newStart: Date, newEnd: Date) => void;
	onTimeSlotClick: (hour: number, day: Date) => void;
	onEventUpdate?: (eventId: string, updatedEvent: { title: string; start: Date; end: Date; description?: string }) => void;
	onEventDelete?: (eventId: string) => void;
}

export const CalendarView = ({
	events,
	viewMode,
	selectedDate,
	onEventClick,
	onDateClick,
	onEventDrop,
	onTimeSlotClick,
	onEventUpdate,
	onEventDelete
}: CalendarViewProps) => {
	console.log(`Rendering ${viewMode} view with ${events.length} events`);

	if (viewMode === 'week') {
		return (
			<div className="flex-1 overflow-auto relative">
				<WeekTimeGrid
					currentDate={selectedDate}
					onTimeSlotClick={onTimeSlotClick}
					events={events}
					onEventUpdate={onEventUpdate}
					onEventDelete={onEventDelete}
					// We've removed the onEventDrop prop to disable drag and drop
				/>
			</div>
		);
	}

	if (viewMode === 'day') {
		return <DayView currentDate={selectedDate} />;
	}

	return <MonthView currentDate={selectedDate} />;
};
